import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';


const Confirmation = ({title, content, open, onClose, onResponse}) => {
    const descriptionElementRef = React.useRef(null);
    //TRANSLATION
    const [t, i18n] = useTranslation("global");

    const close = () => {
        onClose();
        onResponse(false);
    }

    const response = (result) => {
        onClose();
        onResponse(result);
    }


    return(
        <>
            <Dialog
                open={open}  // Controlado completamente por el padre
                onClose={close}
                aria-labelledby="alert-dialog-title"
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                    <IconButton
                        aria-label="close"
                        onClick={close}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {content}
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>response(true)} color="primary" autoFocus>
                        {t("ui.yesButton")}
                    </Button>
                    <Button onClick={()=>response(false)} color="primary" autoFocus>
                        {t("ui.noButton")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Confirmation;